import { Box, Button, HStack, Stack, Text } from 'tcm-chakra-ui'
import { useEffect } from 'react'

type StartOverConfirmModalProps = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function StartOverConfirmModal({
  open,
  onCancel,
  onConfirm,
}: StartOverConfirmModalProps) {
  useEffect(() => {
    if (!open) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCancel()
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [open, onCancel])

  if (!open) return null

  return (
    <Box
      position="fixed"
      inset={0}
      bg="rgba(15, 23, 42, 0.45)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={1600}
      px={4}
      role="dialog"
      aria-modal="true"
      aria-label="Close encounter confirmation"
      onClick={onCancel}
    >
      <Box
        w="100%"
        maxW="28rem"
        borderRadius="xl"
        borderWidth="1px"
        borderColor="border.gray"
        bg="background.primary"
        boxShadow="2xl"
        p={5}
        onClick={(event) => event.stopPropagation()}
      >
        <Stack gap={4}>
          <Stack gap={1}>
            <Text color="text.brandDark" fontSize="lg" fontWeight="700">
              Close encounter?
            </Text>
            <Text color="text.secondary" fontSize="sm">
              Your current progress will be cleared and the flow will return to Patient Lookup.
            </Text>
          </Stack>

          <HStack justify="flex-end" gap={3}>
            <Button
              variant="outline"
              css={{
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'border.gray',
                borderRadius: 'md',
                px: 5,
                minH: 10,
                fontWeight: 600,
                backgroundColor: 'background.primary',
              }}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              colorPalette="red"
              variant="solid"
              css={{
                bg: 'background.surfaceError',
                color: 'text.white',
                px: 5,
                minH: 10,
                borderRadius: 'md',
                fontWeight: 700,
              }}
              onClick={onConfirm}
            >
              Close Encounter
            </Button>
          </HStack>
        </Stack>
      </Box>
    </Box>
  )
}
